export default __webpack_public_path__ + "static/media/absolute-2.e036ce41.png";